



















import { Component, Prop, Vue } from "vue-property-decorator";
import CustomChart, { CustomChartItem } from "./CustomChart.vue";

export const exampleData = [
  {
    color: "#64A70B",
    data: [9],
  },
  {
    color: "#e1e2e5",
    data: [3],
  },
];

@Component({
  components: {
    CustomChart,
  },
})
export default class PieChart extends Vue {
  @Prop({ default: () => [] }) readonly labels!: string[];
  @Prop({ required: true }) readonly items!: CustomChartItem[];
  @Prop({ default: "pie" }) readonly type!: string;
  @Prop({ default: 300 }) readonly width!: number;
  @Prop({ default: 300 }) readonly height!: number;

  get size() {
    return { width: this.width + "px", height: this.height + "px" };
  }

  get options() {
    return {
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
        },
      },
      legend: {
        display: false,
        padding: 0,
      },
      title: {
        display: false,
      },
    };
  }
}
